export enum ItemVerificationView {
    Search = 0,
    NotVerified = 1,
    LPs = 2,
    ShortedItems = 3,
    Changes = 4,
    Returns = 5,
    PoDetails = 6
}